exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carpooling-description[data-v-0fe5d752] {\n  display: block;\n  margin-top: 10px;\n}\n", ""]);

// exports
